import { useState } from "react";
import { BellRing } from "lucide-react";
import { toast } from "sonner";
import { createRestockAlert, errText } from "@/lib/api";

export const RestockForm = ({ p, color, size, onClose }) => {
  const [email, setEmail] = useState("");
  const [crew, setCrew] = useState(false);
  const [done, setDone] = useState(null);
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { const r = await createRestockAlert(p.slug, { email, color, size, newsletter: crew }); setDone(r.message); toast.success(r.message); } catch (err) { toast.error(errText(err)); }
    setBusy(false);
  };
  return (
    <div className="rounded-[16px] border-[1.5px] border-ink bg-sky/40 p-4" data-testid="restock-form">
      <div className="flex items-start justify-between gap-3">
        <p className="font-a text-[15px]"><BellRing size={15} className="mr-1.5 inline" />Notify me: {color} · {size === "OS" ? "One size" : size}</p>
        <button onClick={onClose} className="label !text-[10px] underline" data-testid="restock-close">Close</button>
      </div>
      {done ? <p className="label mt-3 font-bold" data-testid="restock-done">{done}</p> : (
        <form onSubmit={submit} className="mt-3">
          <div className="flex overflow-hidden rounded-[12px] border-[1.5px] border-ink bg-cloud">
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="your@email.com" aria-label="Email for restock alert" className="min-w-0 flex-1 bg-transparent px-4 py-3 text-sm outline-none" data-testid="restock-email" />
            <button disabled={busy} className="btn btn-ink !h-auto !rounded-none px-5" data-testid="restock-submit">{busy ? "…" : "Notify me"}</button>
          </div>
          <label className="mt-2 flex items-center gap-2 text-[13px]"><input type="checkbox" checked={crew} onChange={(e) => setCrew(e.target.checked)} data-testid="restock-newsletter" /> Also join the Sus Crew newsletter</label>
        </form>
      )}
    </div>
  );
};
